// src/pages/admin/Page_Video360/Page_Video360.js
import React, { useState } from "react";
import { Button, Icon, Message } from "semantic-ui-react";

import { useVideo360Controller } from "./useVideo360Controller";

import styles from "./styles.module.css";

import { UploadExperienceForm } from "../../../components/Admin/media360/ui/UploadExperienceForm";
import { ExperienceList } from "../../../components/Admin/media360/ui/ExperienceList";

export function Page_Video360() {
  const { state, actions } = useVideo360Controller();

  const [lastResult, setLastResult] = useState(null);

  const disabled = state.loading || state.uploading;

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Media360</h2>
      <div className={styles.subtitle}>
        Subida y gestión de experiencias (vídeo / imagen) con loop y audio
        opcional.
        <br />
        El emparejamiento media+audio se hace por convención de nombre (sin
        tocar backend).
      </div>

      <div className={styles.card}>
        <UploadExperienceForm
          uploading={state.uploading}
          disabled={disabled}
          uploadProgress={state.uploadProgress}
          uploadProgressKnown={state.uploadProgressKnown}
          error={state.error}
          onUpload={actions.doUploadExperience}
          onUploaded={(res) => setLastResult(res)}
        />
      </div>

      {lastResult?.playerUrl && (
        <div className={styles.card}>
          <Message positive>
            <Message.Header>Subida completada</Message.Header>

            <div className={styles.resultRow}>
              <div className={styles.resultLabel}>Player URL</div>
              <div className={styles.resultValue}>{lastResult.playerUrl}</div>
              <div className={styles.resultActions}>
                <Button
                  size="tiny"
                  primary
                  onClick={() =>
                    window.open(
                      lastResult.playerUrl,
                      "_blank",
                      "noopener,noreferrer",
                    )
                  }
                >
                  <Icon name="external" /> Abrir
                </Button>
                <Button
                  size="tiny"
                  onClick={() =>
                    navigator.clipboard.writeText(lastResult.playerUrl)
                  }
                >
                  <Icon name="copy" /> Copiar
                </Button>
              </div>
            </div>

            <div className={styles.resultRow}>
              <div className={styles.resultLabel}>Media URL</div>
              <div className={styles.resultValue}>
                {lastResult.media?.publicUrl || lastResult.publicUrl || ""}
              </div>
            </div>

            {lastResult.audio?.publicUrl && (
              <div className={styles.resultRow}>
                <div className={styles.resultLabel}>Audio URL</div>
                <div className={styles.resultValue}>
                  {lastResult.audio.publicUrl}
                </div>
              </div>
            )}

            <div className={styles.resultActionsInline}>
              <Button
                size="tiny"
                basic
                onClick={() => actions.reload()}
                disabled={disabled}
              >
                <Icon name="refresh" /> Refrescar listado
              </Button>
            </div>
          </Message>
        </div>
      )}

      <div className={styles.sectionHeader}>
        <h3 className={styles.sectionTitle}>Experiencias</h3>
        <Button
          size="tiny"
          basic
          onClick={actions.reload}
          disabled={disabled}
          title="Refrescar experiencias"
        >
          <Icon name="refresh" /> Recargar
        </Button>
      </div>

      <ExperienceList
        experiences={state.experiences}
        loading={state.loading}
        error={state.error}
        buildPlayerUrlFromExperience={actions.buildPlayerUrlFromExperience}
        onDeleteExperience={actions.doDeleteExperience}
        disabled={disabled}
      />

      {state.nextPageToken && (
        <Button
          fluid
          onClick={actions.loadMore}
          disabled={disabled}
          className={styles.loadMore}
        >
          <Icon name="angle down" /> Cargar más
        </Button>
      )}
    </div>
  );
}

export default Page_Video360;
